import {Col} from 'reactstrap';
import React, {Fragment} from 'react';

class Error404 extends React.Component {
    constructor(props) {
        super(props)
    }

    render = () => {
        return (
            <Fragment>
                <div className="h-100 bg-plum-plate bg-animation">
                    <div className="d-flex h-100 justify-content-center align-items-center">
                        <Col md="8" className="mx-auto app-login-box text-center">
                            <img
                                alt="simpexa"
                                width={130}
                                src={require('../../assets/utils/images/logo-white.png')}
                            />
                            <h1 className="text-center text-light mt-5">404 - Page not found.</h1>
                        </Col>
                    </div>
                </div>
            </Fragment>
        )
    }
}


export default Error404
